import type { StatsigUser } from '@statsig/react-bindings';

export interface TelemetryUser {
  readonly actorDescopeId?: string;
  readonly actorEmail?: string;
  readonly descopeId?: string;
  readonly email?: string;
  readonly firstName?: string;
  readonly lastName?: string;
}

/**
 * Maps our internal user representation to Statsig's user format.
 * Based on implementation from forge/glados.
 * @see https://docs.statsig.com/sdks/user#user-attributes
 */
export function mapUserToStatsig(user?: TelemetryUser): StatsigUser {
  if (!user) {
    return {};
  }

  const { actorDescopeId, actorEmail, descopeId, email, firstName, lastName } =
    user;

  return {
    customIDs: {
      /**
       * When the user has delegated authority to a third party (e.g. if the
       * user is being impersonated), this represents the third party's Descope ID.
       */
      ...(actorDescopeId ? { actorDescopeId } : {}),

      // The user's Descope ID.
      ...(descopeId ? { descopeId } : {}),

      // Do not set `stableID`. Statsig will generate it automatically.
    },

    privateAttributes: {
      /**
       * When the user has delegated authority to a third party (e.g. if the
       * user is being impersonated), this represents the third party's email address.
       */
      ...(actorEmail ? { actorEmail } : {}),
      ...(email ? { email } : {}),
      ...(firstName ? { firstName } : {}),
      ...(lastName ? { lastName } : {}),
    },

    userAgent: window.navigator.userAgent,
    userID: descopeId,
  };
}
